import React, { useRef, useEffect, useState } from "react";
import Button from "../../../Compoents/Button/Button";
import useAppStore from "../../../StateStore/ZustandStore";
import "./HeadingSection.css";

const HeadingSection = ({ onPressLearnMore }) => {
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const setModal = useAppStore((state) => state.setModal);

  useEffect(() => {
    // Auto-play video when component mounts
    if (videoRef.current) {
      videoRef.current.addEventListener("loadeddata", () => {
        setIsVideoLoaded(true);
      });

      videoRef.current.play().catch((error) => {
        // Fallback to static background
        setIsVideoLoaded(false);
      });
    }
  }, []);

  return (
    <section className="heading-section">
      {/* Video Background */}
      {!isVideoLoaded && <div className="fallback-background" />}
      <video
        ref={videoRef}
        className={`video-background ${isVideoLoaded ? "loaded" : ""}`}
        autoPlay
        muted
        loop
        playsInline
        poster="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80"
      >
        <source
          src="https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2FFront%20Video.mp4?alt=media&token=60a15cc4-0ad1-4839-bf17-cbf36832506b"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay */}
      <div className="overlay" />

      {/* Content Container */}
      <div className="content-container">
        <div className="content">
          {/* Main Heading */}
          <h1 className="main-heading">We Don't Sell Software.</h1>

          {/* Sub Heading */}
          <h2 className="sub-heading">We Engineer Your Business Ecosystem.</h2>

          <p
            className="description"
            style={{ color: "white", width: "100%", maxWidth: 800, marginBottom: 30 }}
          >
            Every business is different — so your software should be too. Instead of forcing you
            into rigid, off-the-shelf tools, we design and build a fully customized digital
            ecosystem that mirrors how your business actually operates.
          </p>

          {/* Call to Action Button */}
          <Button
            title="LEARN IN SHORT"
            onPress={() => setModal("CompanyIntro")}
            variant="primary"
            size="large"
          />
        </div>
      </div>

      {/* Animated Elements */}
      <div className="animated-elements">
        {/* Tech Grid Lines */}
        <div className="grid-line grid-line-1" />
        <div className="grid-line grid-line-2" />
        <div className="grid-line grid-line-3" />

        {/* Floating Dots */}
        <div className="floating-dot dot-1" />
        <div className="floating-dot dot-2" />
        <div className="floating-dot dot-3" />
        <div className="floating-dot dot-4" />
      </div>
    </section>
  );
};

export default HeadingSection;
